export default __webpack_public_path__ + "static/rasimas-844922d25fbe6e5bc553324f8f27d97a.jpg";